import React from "react";
import "./homeSecTh.scss";
import { sec3 } from "../../data/MainData";
import Cards from "../../component/Cards";
import Separator from "../../component/Separator";
import Bulb from "../../component/Bulb";
import usePortfolioProjects from "../../hooks/usePortfolioProjects";


export default function HomeSecThree() {
  const projects = usePortfolioProjects();

  return (
    <div id="project" className="th-container">
      <div data-aos="fade-down">
        <Bulb className="bulb-ligh" />
      </div>

      <div className="th-inner">
        <h1 className="team-title" data-aos="fade-up">
          {sec3.title}
        </h1>

        <p className="team-description" data-aos="fade-up">
          {sec3.des1}
        </p>

        <div data-aos="fade-up">
          <Separator />
        </div>

        <div className="team-grid" data-aos="fade-up">
          {projects.map((item) => (
            <div key={item.id}>
              <Cards
                images={item.imageUrl}
                heading={item.heading}
                tag={item.tag}
                url={item.url}
              />
            </div>
          ))}
        </div>
        <div className="main-btn top-btn">
          {/* {<AlertMessage
            label={label.label4}
          />} */}
        </div>
      </div>
    </div>
  );
}
